import { computed } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import constants from '@/utilities/constants';
import { MyWorkTabId } from '@/types/tabs';

export const useMyWorkMemberRoute = () => {
  const store = useStore();
  const route = useRoute();

  const myWorkUserId = computed(() => {
    return store.getters.getMyWorkUserId;
  });

  const selectedTabId = computed(() => {
    return store.getters.getMyWorkSelectedTabId(myWorkUserId.value);
  });

  const isMyWorkOrMemberRoute = computed(() => {
    const routeName = typeof route.name === 'string' ? route.name : '';
    return [constants.myWorkRouteName, constants.memberRouteName].includes(routeName);
  });

  const myWorkRouteUserId = computed(() => {
    return route.params.userId;
  });

  const isMyWorkAssignedTab = computed(() => {
    return selectedTabId.value === MyWorkTabId.Assigned;
  });

  const isMyWorkCreatedTab = computed(() => {
    return selectedTabId.value === MyWorkTabId.Created;
  });

  const isMyWorkCheckinTab = computed(() => {
    return selectedTabId.value === MyWorkTabId.Checkin;
  });

  return {
    isMyWorkOrMemberRoute,
    isMyWorkAssignedTab,
    isMyWorkCreatedTab,
    isMyWorkCheckinTab,
    selectedTabId,
    myWorkUserId,
    myWorkRouteUserId,
  };
};
